import isClient from './isClient'

export default ({ name }) => {

  if (!isClient()) {
    return { experiment: '', variant: '' }
  }

  if (window.vwo_experiment) {
    const experiment = window.vwo_experiment || ""
    const variant = window.vwo_experiment[name] || ""
    const variantAB = variant === 'control' ? 'a' : 'b'
    const vwoData = { experiment: name, variant: variantAB }

    console.log({
      windowVwoExperiment: window.vwo_experiment,
      windowVwoExperimentName: window.vwo_experiment[name],
      experiment,
      variant,
      variantAB,
      vwoData
    });

    return vwoData
  }
}